
import { Component, Vue, Prop} from 'vue-property-decorator';
import PropertyDivisionCompanionAnimalSurvey from "./PropertyDivisionCompanionAnimalSurvey.vue";
import { stepInfoType, stepResultInfoType } from "@/types/Application";
import PageBase from "../../PageBase.vue";

import LegalAssistanceFaqDropdown from "@/components/utils/FaqDropdowns/LegalAssistanceFaqDropdown.vue";
import OtherPartyNotSpouseFaqDropdown from "@/components/utils/FaqDropdowns/OtherPartyNotSpouseFaqDropdown.vue";
import PossessionCompanionFaqDropdown from "@/components/utils/FaqDropdowns/PossessionCompanionFaqDropdown.vue";

import { namespace } from "vuex-class";   
import "@/store/modules/application";
import { stepsAndPagesNumberInfoType } from '@/types/Application/StepsAndPages';
const applicationState = namespace("Application");

@Component({
    components:{
        LegalAssistanceFaqDropdown,
        OtherPartyNotSpouseFaqDropdown,
        PossessionCompanionFaqDropdown,
        PropertyDivisionCompanionAnimalSurvey,
        PageBase
    }
})
export default class PropertyDivisionCompanionAnimal extends Vue {

    @Prop({required: true})
    step!: stepInfoType

    @applicationState.State
    public stPgNo!: stepsAndPagesNumberInfoType;

    @applicationState.State
    public steps!: stepInfoType[];    

    @applicationState.Action
    public UpdateStepResultData!: (newStepResultData: stepResultInfoType) => void

    currentStep =0;
    currentPage =0;
    showTable = true;

    animalData = [];
    anyRowToBeEdited = null;
    editId = null; 
    incompleteError =  false;  

    
    public openForm(anyRowToBeEdited?) {
        this.showTable = false;
        Vue.nextTick(()=>{
            const el = document.getElementById('animal-info-survey')
            if(el) el.scrollIntoView();
        })
        if(anyRowToBeEdited) {
            this.editId = anyRowToBeEdited.id;
            this.anyRowToBeEdited = anyRowToBeEdited;
        } else {
            this.anyRowToBeEdited = null;
        }
    }

    public animalComponentData(value) {       
        this.showTable = value;
    }

    public populateSurveyData(animalValue) {

        const currentIndexValue = this.animalData?.length > 0 ? this.animalData[this.animalData.length - 1].id : 0;
        const id = currentIndexValue + 1;
        const newAnimal = { ...animalValue, id };
        this.animalData = [...this.animalData, newAnimal];
        this.showTable = true;
    }

    public deleteRow(rowToBeDeleted) {
       
        this.animalData = this.animalData.filter(data => {
            return data.id !== rowToBeDeleted;
        }); 
        this.surveyHasError();
    }

    public editRow(editedRow) {
        this.animalData = this.animalData.map(data => {
            return data.id === this.editId ? editedRow : data;
        });
        this.showTable = true;
        this.surveyHasError();
    }

    public onPrev() {
       Vue.prototype.$UpdateGotoPrevStepPage();
    }

    public onNext() {
        Vue.prototype.$UpdateGotoNextStepPage();
    }

    created() {
        if (this.step.result?.propertyDivisionCompanionAnimalSurvey) {
            this.animalData = this.step.result.propertyDivisionCompanionAnimalSurvey.data;
        }
    }

    mounted(){
        Vue.nextTick(()=>this.surveyHasError());
        this.currentStep = this.$store.state.Application.currentStep;
        this.currentPage = this.$store.state.Application.steps[this.currentStep].currentPage;        
    }

    public surveyHasError(){
        let progress = this.animalData.length==0? 50 : 100;
        this.incompleteError =  false;        
        for(const animal of this.animalData){
            if (!animal.animalType || !animal.animalName || !animal.animalOwnership ){            
                this.incompleteError = true;  
                progress = 50;    
                break
            }
        }        
        Vue.filter('setSurveyProgress')(null, this.currentStep, this.currentPage, progress, false);
    }

    public isDisableNext() {
        return (this.animalData?.length <= 0);
    }

    beforeDestroy() {
        this.surveyHasError();        
        this.UpdateStepResultData({step:this.step, data: {propertyDivisionCompanionAnimalSurvey: this.getAnimalResults()}})       
    }

    public getAnimalResults(){
        const questionResults: {name:string; value: any; title:string; inputType:string}[] =[];
        for(const animal of this.animalData)
        {
            questionResults.push({name:'propertyDivisionCompanionAnimalSurvey', value: this.getAnimalInfo(animal), title:'Companion Animal '+animal.id +' Information', inputType:''})
        }
        
        return {data: this.animalData, questions:questionResults, pageName:'Companion Animal Information', currentStep: this.currentStep, currentPage:this.currentPage}
    }

    public getAnimalInfo(animal){
        const resultString = [];
        resultString.push(Vue.filter('styleTitle')("Name of Companion Animal: ")+animal.animalName);
        resultString.push(Vue.filter('styleTitle')("Type of Animal: ")+animal.animalType);
        resultString.push(Vue.filter('styleTitle')("Sole Ownership and Possession to: ")+animal.animalOwnership);        
        return resultString
    }

}
